import React, { createContext, useState } from 'react'

const Context = createContext()

export const RoutesProvider = ({ children }) => {
  const [currentRoute, setCurrentRoute] = useState([])

  return (
    <Context.Provider value={{ currentRoute, setCurrentRoute }}>
      {children}
    </Context.Provider>
  )
}

export default Context
